import React from 'react';
import ReactPlayer from 'react-player'
import Button from '../Button';
import Row from '../Row';
import Col from '../Col';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

class Video extends React.Component {
  state = {
    playingVideo: false
  }
  playVideo() {
    // You can use the play method as normal on your video ref
    this.setState({ playingVideo: true })
    //this.refs.vidRef.getInternalPlayer().playVideo()
  }

  pauseVideo(type) {
    // Pause as well
    this.refs.vidRef.getInternalPlayer().pauseVideo()
    this.setState({playingVideo: false})
    if(type === 'pause') {
    } else {
      this.props.onClose();
    }
  }

  // You can pass your function references to your child components as props (here passing down to the Buttons component)
  render() {
    const { videoObj, propertyVideos } = this.props;
    return (
      <div style={{ backgroundColor: 'black', height: '100%', width: '100%', padding: 30, paddingTop: 50 }}>
        <Row>
          <Swiper
            style={{ height: '80%', width: '80%'}}
            spaceBetween={50}
            slidesPerView={1}
            onSlideChange={() => this.pauseVideo('pause')}
            onSwiper={(swiper) => console.log('')}
            navigation={propertyVideos && propertyVideos.length === 1 ? false : true}
            pagination={{ clickable: true }}
            // scrollbar={{ draggable: true }}
          >
            {propertyVideos.map((item, i) => {
              
              return (
              <SwiperSlide
              >
                <ReactPlayer
                  url={item.attachment && item.attachment.image ? item.attachment.image : item.attachment && item.attachment.embed ? item.attachment.embed: null}
                  width='100%'
                  // height='40%'
                  pip={true}
                  ref="vidRef"
                  controls={true}
                 playing={this.state.playingVideo}
                />

              </SwiperSlide>
            )}
            )}
          </Swiper>
        </Row>
        <div style={{ marginTop: 20 }}>
          <Row mdCenter>
            <Button
              color="complete_purple"
              label="Close"
              onClick={() => this.pauseVideo()}
              size="bar"
            />
          </Row>
        </div>
      </div>
    );
  }
}

export default Video;